export enum ValidationTrigger {
  AfterTouchOnChange = "AfterTouchOnChange",
  OnChange = "OnChange",
  OnSubmitOnly = "OnSubmitOnly",
}
